import CachedIcon from '@mui/icons-material/Cached';
import EditIcon from '@mui/icons-material/Edit';
import { Card, CardContent, CardHeader, IconButton, Typography } from "@mui/material";
import * as React from "react";
import { Cpn4GLteSettingModel, UpdateResult } from '../../../models';

import CircularProgress from '@mui/material/CircularProgress';
import { connect } from "react-redux";
import { actionCreators, ApplicationState, FetchState, selectors } from "../../../store";
import { changeDisabledPollingBtn, showUnit } from '../../../utils';
import Select4GLteSettingDialog from '../../dialogs/Select4GLteSettingDialog';
import FetchHelper from '../../FetchHelper';
import { disabledRefreshAllBtnStyle, disabledRefreshSuccessIconStyles, enableRefreshAllBtnStyle, enableRefreshSuccessIconStyles, pollingColStyle, pollingColStyleTitle } from '../../styles';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';

const NO_OF_POLLING_TOPIC = 16;

const params = {
    mainid: "",
    isRefreshAllBegin: 0,
    isRefreshAllCompleted: (status: number) => { },
    loadingRefreshAll: [false],
    isEdit: false,
    setIsEdit: (isEdit: boolean) => { },
    setRefreshGroup: (disabled: boolean, name: string) => { },
    isRefreshGroup: false,
    setDisabledRefreshGroupBtn: (disabled: boolean, name: string) => { },
    isDisbleRefeshBtn: true,
    isDisbleUpdateBtn: true,
}
const fetchId = "DATA_4G_LTE_SETTING_FETCH";

type Cpn4GLteSettingProps = {
    defaultData: Cpn4GLteSettingModel[] | undefined;
};

export type PureCpn4GLteSettingProps = Cpn4GLteSettingProps & ReturnType<typeof mapStateToProps> &
    typeof mapDispatchToProps & typeof params;

export const Cpn4GLteSetting = (props: PureCpn4GLteSettingProps) => {
    const { defaultData, fetchState, mainid, isRefreshAllBegin, loadingRefreshAll, isEdit, isRefreshGroup, isDisbleRefeshBtn, isDisbleUpdateBtn } = props;
    const { onError, onUpdate, onRefresh, onUpdateSuccess, onUpdateError, isRefreshAllCompleted, setIsEdit, setRefreshGroup, setDisabledRefreshGroupBtn } = props;
    const [openSelectDialog, setOpenSelectDialog] = React.useState(false);
    const [updateData, setUpdateData] = React.useState<any>();
    const [data4GLteSetting0, setData4GLteSetting0] = React.useState<Cpn4GLteSettingModel>(fetchState.data);
    const [data4GLteSetting1, setData4GLteSetting1] = React.useState<Cpn4GLteSettingModel>(fetchState.data);
    const [data4GLteSetting2, setData4GLteSetting2] = React.useState<Cpn4GLteSettingModel>(fetchState.data);
    const [data4GLteSetting3, setData4GLteSetting3] = React.useState<Cpn4GLteSettingModel>(fetchState.data);
    const [data4GLteSetting4, setData4GLteSetting4] = React.useState<Cpn4GLteSettingModel>(fetchState.data);
    const [editData, setEditData] = React.useState<Cpn4GLteSettingModel>();
    const [fetchLoadingDevice0, setFetchLoadingDevice0] = React.useState(false);
    const [fetchLoadingDevice1, setFetchLoadingDevice1] = React.useState(false);
    const [fetchLoadingDevice2, setFetchLoadingDevice2] = React.useState(false);
    const [fetchLoadingDevice3, setFetchLoadingDevice3] = React.useState(false);
    const [fetchLoadingDevice4, setFetchLoadingDevice4] = React.useState(false);
    const [editFlg, setEditFlg] = React.useState(new Array(5).fill('').map(() => false));
    const [isFetchAll, setIsFetchAll] = React.useState(false);
    const [isRefreshSuccess0, setIsRefreshSuccess0] = React.useState(false);
    const [isRefreshSuccess1, setIsRefreshSuccess1] = React.useState(false);
    const [isRefreshSuccess2, setIsRefreshSuccess2] = React.useState(false);
    const [isRefreshSuccess3, setIsRefreshSuccess3] = React.useState(false);
    const [isRefreshSuccess4, setIsRefreshSuccess4] = React.useState(false);

    const deviceNos = ['00', '01', '02', '03', '04'];
    const deviceNames = ['親機', '子機1', '子機2', '子機3', '子機4'];

    // パラメータ設定
    const handleFetchParams = (deviceNo: string) => {
        const params = new Map<string, any>();
        const code = "QL";
        params.set("code", code);
        params.set("mainid", mainid);
        params.set("device_no", deviceNo);
        return params;
    }

    const handleFetchSuccess = (data: any, action: string, isClickedRefreshBtn: boolean) => {
        setEditFlg(changeDisabledPollingBtn(false, data.device_no, deviceNos, editFlg));
        (loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] === true) && (loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] = false);
        const resData = {
            mainid: data.mainid,
            deviceNo: data.device_no,
            serverIpAddr: data.server_ip_addr,
            serverPort: data.server_port,
            modemIpAddr: data.modem_ip_addr,
            modemPort: data.modem_port,
            serverTime: data.server_time,
            ackTime: data.ack_time,
            lastGetDatetime: data.last_get_datetime,
        } as Cpn4GLteSettingModel;

        switch (data.device_no) {
            case deviceNos[0]:
                setData4GLteSetting0(resData);
                setFetchLoadingDevice0(false);
                (isRefreshAllBegin === NO_OF_POLLING_TOPIC || isRefreshGroup === true) && handleRefresh(deviceNos[1]);
                isClickedRefreshBtn && setIsRefreshSuccess0(true);
                break;
            case deviceNos[1]:
                setData4GLteSetting1(resData);
                setFetchLoadingDevice1(false);
                (isRefreshAllBegin === NO_OF_POLLING_TOPIC || isRefreshGroup === true) && handleRefresh(deviceNos[2]);
                isClickedRefreshBtn && setIsRefreshSuccess1(true);
                break;
            case deviceNos[2]:
                setData4GLteSetting2(resData);
                setFetchLoadingDevice2(false);
                (isRefreshAllBegin === NO_OF_POLLING_TOPIC || isRefreshGroup === true) && handleRefresh(deviceNos[3]);
                isClickedRefreshBtn && setIsRefreshSuccess2(true);
                break;
            case deviceNos[3]:
                setData4GLteSetting3(resData);
                setFetchLoadingDevice3(false);
                (isRefreshAllBegin === NO_OF_POLLING_TOPIC || isRefreshGroup === true) && handleRefresh(deviceNos[4]);
                isClickedRefreshBtn && setIsRefreshSuccess3(true);
                break;
            case deviceNos[4]:
                setData4GLteSetting4(resData);
                setFetchLoadingDevice4(false);
                (isRefreshAllBegin === NO_OF_POLLING_TOPIC) && isRefreshAllCompleted(isRefreshAllBegin + 1);
                isClickedRefreshBtn && setIsRefreshSuccess4(true);
                setRefreshGroup(false, fetchId);
                break;
        }

        if (action === 'edit') {
            setEditData(resData);
            setOpenSelectDialog(true);
        }
    };

    const handleError = (success: boolean, data: any, error: any, deviceNo: string) => {
        onError(success, data, error, deviceNames[Number(deviceNo)]);
        setEditFlg(changeDisabledPollingBtn(false, deviceNo, deviceNos, editFlg));
        (loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] === true) && (loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] = false);
        switch (deviceNo) {
            case deviceNos[0]:
                setFetchLoadingDevice0(false);
                (isRefreshAllBegin === NO_OF_POLLING_TOPIC || isRefreshGroup === true) && handleRefresh(deviceNos[1]);
                setIsRefreshSuccess0(false);
                break;
            case deviceNos[1]:
                setFetchLoadingDevice1(false);
                (isRefreshAllBegin === NO_OF_POLLING_TOPIC || isRefreshGroup === true) && handleRefresh(deviceNos[2]);
                setIsRefreshSuccess1(false);
                break;
            case deviceNos[2]:
                setFetchLoadingDevice2(false);
                (isRefreshAllBegin === NO_OF_POLLING_TOPIC || isRefreshGroup === true) && handleRefresh(deviceNos[3]);
                setIsRefreshSuccess2(false);
                break;
            case deviceNos[3]:
                setFetchLoadingDevice3(false);
                (isRefreshAllBegin === NO_OF_POLLING_TOPIC || isRefreshGroup === true) && handleRefresh(deviceNos[4]);
                setIsRefreshSuccess3(false);
                break;
            case deviceNos[4]:
                setFetchLoadingDevice4(false);
                (isRefreshAllBegin === NO_OF_POLLING_TOPIC) && isRefreshAllCompleted(isRefreshAllBegin + 1);
                setIsRefreshSuccess4(false);
                setRefreshGroup(false, fetchId);
        }
    }

    const handleRefresh = (deviceNo: string) => {
        switch (deviceNo) {
            case deviceNos[0]:
                setFetchLoadingDevice0(true);
                setIsRefreshSuccess0(false);
                break;
            case deviceNos[1]:
                setFetchLoadingDevice1(true);
                setIsRefreshSuccess1(false);
                break;
            case deviceNos[2]:
                setFetchLoadingDevice2(true);
                setIsRefreshSuccess2(false);
                break;
            case deviceNos[3]:
                setFetchLoadingDevice3(true);
                setIsRefreshSuccess3(false);
                break;
            case deviceNos[4]:
                setFetchLoadingDevice4(true);
                setIsRefreshSuccess4(false);
                break;
        }
        const params = handleFetchParams(deviceNo);
        onRefresh(params, fetchId + deviceNo);
    };

    const handleRefreshSuccess = (data: any, deviceNo: string) => {
        const deviceIndex = deviceNos.findIndex((element) => element === data.device_no);
        editFlg[deviceIndex] ? handleFetchSuccess(data, 'edit', true) : handleFetchSuccess(data, 'view', true);
    }

    const [updateDialogTitle, setUpdateDialogTitle] = React.useState('');
    // const handleEdit = (deviceNo: string) => {
    //     setEditFlg(changeDisabledPollingBtn(true, deviceNo, deviceNos, editFlg));
    //     const params = handleFetchParams(deviceNo);
    //     onRefresh(params, fetchId + deviceNo);
    //     switch (deviceNo) {
    //         case deviceNos[0]:
    //             setUpdateDialogTitle('4G LTE設定/親機');
    //             setFetchLoadingDevice0(true);
    //             setIsRefreshSuccess0(false);
    //             break;
    //         case deviceNos[1]:
    //             setUpdateDialogTitle('4G LTE設定/子機1');
    //             setFetchLoadingDevice1(true);
    //             setIsRefreshSuccess1(false);
    //             break;
    //         case deviceNos[2]:
    //             setUpdateDialogTitle('4G LTE設定/子機2');
    //             setFetchLoadingDevice2(true);
    //             setIsRefreshSuccess2(false);
    //             break;
    //         case deviceNos[3]:
    //             setUpdateDialogTitle('4G LTE設定/子機3');
    //             setFetchLoadingDevice3(true);
    //             setIsRefreshSuccess3(false);
    //             break;
    //         case deviceNos[4]:
    //             setUpdateDialogTitle('4G LTE設定/子機4');
    //             setFetchLoadingDevice4(true);
    //             setIsRefreshSuccess4(false);
    //             break;
    //     }
    // };

    const handleUpdateOk = (request: any) => {
        setOpenSelectDialog(false);
        const code = "QM";
        const requestData = {
            mainid: request.mainid,
            device_no: request.device_no,
            server_ip_addr: request.server_ip_addr,
            server_port: request.server_port,
            modem_ip_addr: request.modem_ip_addr,
            modem_port: request.modem_port,
            server_time: request.server_time,
            ack_time: request.ack_time,
        }
        onUpdate(code, mainid, requestData);
        setUpdateData(request);
        switch (request.device_no) {
            case deviceNos[0]:
                setFetchLoadingDevice0(true);
                setIsRefreshSuccess0(false);
                break;
            case deviceNos[1]:
                setFetchLoadingDevice1(true);
                setIsRefreshSuccess1(false);
                break;
            case deviceNos[2]:
                setFetchLoadingDevice2(true);
                setIsRefreshSuccess2(false);
                break;
            case deviceNos[3]:
                setFetchLoadingDevice3(true);
                setIsRefreshSuccess3(false);
                break;
            case deviceNos[4]:
                setFetchLoadingDevice4(true);
                setIsRefreshSuccess4(false);
                break;
        }
    };

    const handleUpdateCancel = () => {
        setOpenSelectDialog(false);
    };

    const handleUpdateSuccess = (success: boolean, data: any, error: any) => {
        const result = {
            mainid: data.mainid,
            deviceNo: data.device_no,
            resultCode: data.result_code,
        } as UpdateResult;
        if (result.resultCode === '0') {
            handleFetchSuccess(updateData, 'view', true);
            onUpdateSuccess(deviceNames[Number(result.deviceNo)]);
        } else {
            handleUpdateError(success, data, error);
        }
    }

    const handleUpdateError = (success: boolean, data: any, error: any) => {
        switch (updateData.device_no) {
            case deviceNos[0]:
                setFetchLoadingDevice0(false);
                setIsRefreshSuccess0(true);
                break;
            case deviceNos[1]:
                setFetchLoadingDevice1(false);
                setIsRefreshSuccess1(true);
                break;
            case deviceNos[2]:
                setFetchLoadingDevice2(false);
                setIsRefreshSuccess2(true);
                break;
            case deviceNos[3]:
                setFetchLoadingDevice3(false);
                setIsRefreshSuccess3(true);
                break;
            case deviceNos[4]:
                setFetchLoadingDevice4(false);
                setIsRefreshSuccess4(true);
                break;
        }
        onUpdateError(success, data, error, deviceNames[Number(updateData.device_no)]);
    }

    const refreshAll = () => {
        if (isRefreshAllBegin === NO_OF_POLLING_TOPIC) {
            console.log("fetch No:______" + isRefreshAllBegin);
            handleRefresh(deviceNos[0]);
        }
        if (isRefreshGroup === true) {
            handleRefresh(deviceNos[0]);
            setFetchLoadingDevice0(true);
            setFetchLoadingDevice1(true);
            setFetchLoadingDevice2(true);
            setFetchLoadingDevice3(true);
            setFetchLoadingDevice4(true);
            setIsRefreshSuccess0(false);
            setIsRefreshSuccess1(false);
            setIsRefreshSuccess2(false);
            setIsRefreshSuccess3(false);
            setIsRefreshSuccess4(false);
        }
        if (loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] === true) {
            setFetchLoadingDevice0(true);
            setFetchLoadingDevice1(true);
            setFetchLoadingDevice2(true);
            setFetchLoadingDevice3(true);
            setFetchLoadingDevice4(true);
            setIsRefreshSuccess0(false);
            setIsRefreshSuccess1(false);
            setIsRefreshSuccess2(false);
            setIsRefreshSuccess3(false);
            setIsRefreshSuccess4(false);
        }
        isRefreshAllBegin > 0 || isRefreshGroup ? setIsFetchAll(true) : setIsFetchAll(false);
    }
    // eslint-disable-next-line
    React.useEffect(refreshAll, [isRefreshAllBegin, loadingRefreshAll, isRefreshGroup]);

    const handleDisabledRefreshAll = () => {
        if (!fetchLoadingDevice0 && !fetchLoadingDevice1 && !fetchLoadingDevice2 && !fetchLoadingDevice3 && !fetchLoadingDevice4) {
            setDisabledRefreshGroupBtn(false, fetchId);
        } else {
            setDisabledRefreshGroupBtn(true, fetchId);
        }
    }
    // eslint-disable-next-line
    React.useEffect(handleDisabledRefreshAll, [fetchLoadingDevice0, fetchLoadingDevice1, fetchLoadingDevice2, fetchLoadingDevice3, fetchLoadingDevice4]);

    React.useEffect(() => {
        [...editFlg].find(item => item === true) === true ? setIsEdit(true) : setIsEdit(false);
        // eslint-disable-next-line
    }, [editFlg])

    React.useEffect(() => {
        defaultData && (
            defaultData.forEach(data => {
                handleFetchSuccess(data, 'view', false);
            })
        )
        // eslint-disable-next-line
    }, [defaultData]);

    return (
        <>
            <Card style={{ margin: '0 auto 12px', backgroundColor: '#f5faff', width: '100%' }}>
                <CardHeader
                    avatar={
                        <PublishedWithChangesIcon style={isRefreshSuccess0 ? enableRefreshSuccessIconStyles : disabledRefreshSuccessIconStyles} />
                    }
                    action={
                        <div>
                            {/* <IconButton aria-label="edit" onClick={() => handleEdit('00')} disabled={isDisbleUpdateBtn || isEdit || fetchLoadingDevice0 || isFetchAll}>
                                <EditIcon fontSize="medium" style={isDisbleUpdateBtn || isEdit === true || fetchLoadingDevice0 || isFetchAll ? disabledRefreshAllBtnStyle : enableRefreshAllBtnStyle} />
                            </IconButton> */}
                            <IconButton aria-label="refresh" onClick={() => handleRefresh('00')} disabled={isDisbleRefeshBtn || editFlg[0] || fetchLoadingDevice0 || isFetchAll}>
                                <CachedIcon fontSize="medium" style={isDisbleRefeshBtn || editFlg[0] === true || fetchLoadingDevice0 || isFetchAll ? disabledRefreshAllBtnStyle : enableRefreshAllBtnStyle} />
                            </IconButton>
                        </div>
                    }
                    title='4G LTE設定/親機'
                    titleTypographyProps={{ variant: 'h5' }}
                />
                <CardContent style={{ padding: '0 0 16px 0' }}>
                    {fetchLoadingDevice0 ? (
                        <div style={{ display: 'flex', position: 'relative' }}>
                            <table className='polling' style={{ borderCollapse: 'collapse', width: '100%', margin: 'auto' }}>
                                <tbody>
                                    <tr>
                                        <td style={pollingColStyleTitle}>Server IPアドレス</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>Server ポート</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>Modem IPアドレス</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>Modem ポート</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>死活監視間隔</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>再送回数</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div style={{ position: 'absolute', top: '40%', left: '60%' }}>
                                <CircularProgress style={{ margin: 'auto' }} />
                            </div>
                        </div>
                    ) : (
                        <table className='polling' style={{ borderCollapse: 'collapse', width: '100%', margin: 'auto' }}>
                            <tbody>
                                <tr>
                                    <td style={pollingColStyleTitle}>Server IPアドレス</td>
                                    <td style={pollingColStyle}>{data4GLteSetting0?.serverIpAddr}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>Server ポート</td>
                                    <td style={pollingColStyle}>{data4GLteSetting0?.serverPort}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>Modem IPアドレス</td>
                                    <td style={pollingColStyle}>{data4GLteSetting0?.modemIpAddr}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>Modem ポート</td>
                                    <td style={pollingColStyle}>{data4GLteSetting0?.modemPort}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>死活監視間隔</td>
                                    <td style={pollingColStyle}>{data4GLteSetting0?.serverTime}{showUnit(data4GLteSetting0?.serverTime, "時間")}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>再送回数</td>
                                    <td style={pollingColStyle}>{data4GLteSetting0?.ackTime}{showUnit(data4GLteSetting0?.ackTime, "回")}</td>
                                </tr>
                            </tbody>
                        </table>
                    )}
                    <Typography display='flex' justifyContent='flex-end' padding='4px 4px 0 0'>最終取得日時：{data4GLteSetting0?.lastGetDatetime ?? '-'}</Typography>
                </CardContent>
            </Card >

            <Card style={{ margin: '0 auto 12px', backgroundColor: '#f5faff', width: '100%' }}>
                <CardHeader
                    avatar={
                        <PublishedWithChangesIcon style={isRefreshSuccess1 ? enableRefreshSuccessIconStyles : disabledRefreshSuccessIconStyles} />
                    }
                    action={
                        <div>
                            {/* <IconButton aria-label="edit" onClick={() => handleEdit('01')} disabled={isDisbleUpdateBtn || isEdit || fetchLoadingDevice1 || isFetchAll}>
                                <EditIcon fontSize="medium" style={isDisbleUpdateBtn || isEdit === true || fetchLoadingDevice1 || isFetchAll ? disabledRefreshAllBtnStyle : enableRefreshAllBtnStyle} />
                            </IconButton> */}
                            <IconButton aria-label="refresh" onClick={() => handleRefresh('01')} disabled={isDisbleRefeshBtn || editFlg[1] || fetchLoadingDevice1 || isFetchAll}>
                                <CachedIcon fontSize="medium" style={isDisbleRefeshBtn || editFlg[1] === true || fetchLoadingDevice1 || isFetchAll ? disabledRefreshAllBtnStyle : enableRefreshAllBtnStyle} />
                            </IconButton>
                        </div>
                    }
                    title='4G LTE設定/子機1'
                    titleTypographyProps={{ variant: 'h5' }}
                />
                <CardContent style={{ padding: '0 0 16px 0' }}>
                    {fetchLoadingDevice1 ? (
                        <div style={{ display: 'flex', position: 'relative' }}>
                            <table className='polling' style={{ borderCollapse: 'collapse', width: '100%', margin: 'auto' }}>
                                <tbody>
                                    <tr>
                                        <td style={pollingColStyleTitle}>Server IPアドレス</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>Server ポート</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>Modem IPアドレス</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>Modem ポート</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>死活監視間隔</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>再送回数</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div style={{ position: 'absolute', top: '40%', left: '60%' }}>
                                <CircularProgress style={{ margin: 'auto' }} />
                            </div>
                        </div>
                    ) : (
                        <table className='polling' style={{ borderCollapse: 'collapse', width: '100%', margin: 'auto' }}>
                            <tbody>
                                <tr>
                                    <td style={pollingColStyleTitle}>Server IPアドレス</td>
                                    <td style={pollingColStyle}>{data4GLteSetting1?.serverIpAddr}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>Server ポート</td>
                                    <td style={pollingColStyle}>{data4GLteSetting1?.serverPort}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>Modem IPアドレス</td>
                                    <td style={pollingColStyle}>{data4GLteSetting1?.modemIpAddr}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>Modem ポート</td>
                                    <td style={pollingColStyle}>{data4GLteSetting1?.modemPort}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>死活監視間隔</td>
                                    <td style={pollingColStyle}>{data4GLteSetting1?.serverTime}{showUnit(data4GLteSetting1?.serverTime, "時間")}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>再送回数</td>
                                    <td style={pollingColStyle}>{data4GLteSetting1?.ackTime}{showUnit(data4GLteSetting1?.ackTime, "回")}</td>
                                </tr>
                            </tbody>
                        </table>
                    )}
                    <Typography display='flex' justifyContent='flex-end' padding='4px 4px 0 0'>最終取得日時：{data4GLteSetting1?.lastGetDatetime ?? '-'}</Typography>
                </CardContent>
            </Card >

            <Card style={{ margin: '0 auto 12px', backgroundColor: '#f5faff', width: '100%' }}>
                <CardHeader
                    avatar={
                        <PublishedWithChangesIcon style={isRefreshSuccess2 ? enableRefreshSuccessIconStyles : disabledRefreshSuccessIconStyles} />
                    }
                    action={
                        <div>
                            {/* <IconButton aria-label="edit" onClick={() => handleEdit('02')} disabled={isDisbleUpdateBtn || isEdit || fetchLoadingDevice2 || isFetchAll}>
                                <EditIcon fontSize="medium" style={isDisbleUpdateBtn || isEdit === true || fetchLoadingDevice2 || isFetchAll ? disabledRefreshAllBtnStyle : enableRefreshAllBtnStyle} />
                            </IconButton> */}
                            <IconButton aria-label="refresh" onClick={() => handleRefresh('02')} disabled={isDisbleRefeshBtn || editFlg[2] || fetchLoadingDevice2 || isFetchAll}>
                                <CachedIcon fontSize="medium" style={isDisbleRefeshBtn || editFlg[2] === true || fetchLoadingDevice2 || isFetchAll ? disabledRefreshAllBtnStyle : enableRefreshAllBtnStyle} />
                            </IconButton>
                        </div>
                    }
                    title='4G LTE設定/子機2'
                    titleTypographyProps={{ variant: 'h5' }}
                />
                <CardContent style={{ padding: '0 0 16px 0' }}>
                    {fetchLoadingDevice2 ? (
                        <div style={{ display: 'flex', position: 'relative' }}>
                            <table className='polling' style={{ borderCollapse: 'collapse', width: '100%', margin: 'auto' }}>
                                <tbody>
                                    <tr>
                                        <td style={pollingColStyleTitle}>Server IPアドレス</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>Server ポート</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>Modem IPアドレス</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>Modem ポート</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>死活監視間隔</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>再送回数</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div style={{ position: 'absolute', top: '40%', left: '60%' }}>
                                <CircularProgress style={{ margin: 'auto' }} />
                            </div>
                        </div>
                    ) : (
                        <table className='polling' style={{ borderCollapse: 'collapse', width: '100%', margin: 'auto' }}>
                            <tbody>
                                <tr>
                                    <td style={pollingColStyleTitle}>Server IPアドレス</td>
                                    <td style={pollingColStyle}>{data4GLteSetting2?.serverIpAddr}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>Server ポート</td>
                                    <td style={pollingColStyle}>{data4GLteSetting2?.serverPort}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>Modem IPアドレス</td>
                                    <td style={pollingColStyle}>{data4GLteSetting2?.modemIpAddr}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>Modem ポート</td>
                                    <td style={pollingColStyle}>{data4GLteSetting2?.modemPort}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>死活監視間隔</td>
                                    <td style={pollingColStyle}>{data4GLteSetting2?.serverTime}{showUnit(data4GLteSetting2?.serverTime, "時間")}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>再送回数</td>
                                    <td style={pollingColStyle}>{data4GLteSetting2?.ackTime}{showUnit(data4GLteSetting2?.ackTime, "回")}</td>
                                </tr>
                            </tbody>
                        </table>
                    )}
                    <Typography display='flex' justifyContent='flex-end' padding='4px 4px 0 0'>最終取得日時：{data4GLteSetting2?.lastGetDatetime ?? '-'}</Typography>
                </CardContent>
            </Card >

            <Card style={{ margin: '0 auto 12px', backgroundColor: '#f5faff', width: '100%' }}>
                <CardHeader
                    avatar={
                        <PublishedWithChangesIcon style={isRefreshSuccess3 ? enableRefreshSuccessIconStyles : disabledRefreshSuccessIconStyles} />
                    }
                    action={
                        <div>
                            {/* <IconButton aria-label="edit" onClick={() => handleEdit('03')} disabled={isDisbleUpdateBtn || isEdit || fetchLoadingDevice3 || isFetchAll}>
                                <EditIcon fontSize="medium" style={isDisbleUpdateBtn || isEdit === true || fetchLoadingDevice3 || isFetchAll ? disabledRefreshAllBtnStyle : enableRefreshAllBtnStyle} />
                            </IconButton> */}
                            <IconButton aria-label="refresh" onClick={() => handleRefresh('03')} disabled={isDisbleRefeshBtn || editFlg[3] || fetchLoadingDevice3 || isFetchAll}>
                                <CachedIcon fontSize="medium" style={isDisbleRefeshBtn || editFlg[3] === true || fetchLoadingDevice3 || isFetchAll ? disabledRefreshAllBtnStyle : enableRefreshAllBtnStyle} />
                            </IconButton>
                        </div>
                    }
                    title='4G LTE設定/子機3'
                    titleTypographyProps={{ variant: 'h5' }}
                />
                <CardContent style={{ padding: '0 0 16px 0' }}>
                    {fetchLoadingDevice3 ? (
                        <div style={{ display: 'flex', position: 'relative' }}>
                            <table className='polling' style={{ borderCollapse: 'collapse', width: '100%', margin: 'auto' }}>
                                <tbody>
                                    <tr>
                                        <td style={pollingColStyleTitle}>Server IPアドレス</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>Server ポート</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>Modem IPアドレス</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>Modem ポート</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>死活監視間隔</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>再送回数</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div style={{ position: 'absolute', top: '40%', left: '60%' }}>
                                <CircularProgress style={{ margin: 'auto' }} />
                            </div>
                        </div>
                    ) : (
                        <table className='polling' style={{ borderCollapse: 'collapse', width: '100%', margin: 'auto' }}>
                            <tbody>
                                <tr>
                                    <td style={pollingColStyleTitle}>Server IPアドレス</td>
                                    <td style={pollingColStyle}>{data4GLteSetting3?.serverIpAddr}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>Server ポート</td>
                                    <td style={pollingColStyle}>{data4GLteSetting3?.serverPort}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>Modem IPアドレス</td>
                                    <td style={pollingColStyle}>{data4GLteSetting3?.modemIpAddr}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>Modem ポート</td>
                                    <td style={pollingColStyle}>{data4GLteSetting3?.modemPort}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>死活監視間隔</td>
                                    <td style={pollingColStyle}>{data4GLteSetting3?.serverTime}{showUnit(data4GLteSetting3?.serverTime, "時間")}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>再送回数</td>
                                    <td style={pollingColStyle}>{data4GLteSetting3?.ackTime}{showUnit(data4GLteSetting3?.ackTime, "回")}</td>
                                </tr>
                            </tbody>
                        </table>
                    )}
                    <Typography display='flex' justifyContent='flex-end' padding='4px 4px 0 0'>最終取得日時：{data4GLteSetting3?.lastGetDatetime ?? '-'}</Typography>
                </CardContent>
            </Card >

            <Card style={{ margin: '0 auto 12px', backgroundColor: '#f5faff', width: '100%' }}>
                <CardHeader
                    avatar={
                        <PublishedWithChangesIcon style={isRefreshSuccess4 ? enableRefreshSuccessIconStyles : disabledRefreshSuccessIconStyles} />
                    }
                    action={
                        <div>
                            {/* <IconButton aria-label="edit" onClick={() => handleEdit('04')} disabled={isDisbleUpdateBtn || isEdit || fetchLoadingDevice4 || isFetchAll}>
                                <EditIcon fontSize="medium" style={isDisbleUpdateBtn || isEdit === true || fetchLoadingDevice4 || isFetchAll ? disabledRefreshAllBtnStyle : enableRefreshAllBtnStyle} />
                            </IconButton> */}
                            <IconButton aria-label="refresh" onClick={() => handleRefresh('04')} disabled={isDisbleRefeshBtn || editFlg[4] || fetchLoadingDevice4 || isFetchAll}>
                                <CachedIcon fontSize="medium" style={isDisbleRefeshBtn || editFlg[4] === true || fetchLoadingDevice4 || isFetchAll ? disabledRefreshAllBtnStyle : enableRefreshAllBtnStyle} />
                            </IconButton>
                        </div>
                    }
                    title='4G LTE設定/子機4'
                    titleTypographyProps={{ variant: 'h5' }}
                />
                <CardContent style={{ padding: '0 0 16px 0' }}>
                    {fetchLoadingDevice4 ? (
                        <div style={{ display: 'flex', position: 'relative' }}>
                            <table className='polling' style={{ borderCollapse: 'collapse', width: '100%', margin: 'auto' }}>
                                <tbody>
                                    <tr>
                                        <td style={pollingColStyleTitle}>Server IPアドレス</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>Server ポート</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>Modem IPアドレス</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>Modem ポート</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>死活監視間隔</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>再送回数</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div style={{ position: 'absolute', top: '40%', left: '60%' }}>
                                <CircularProgress style={{ margin: 'auto' }} />
                            </div>
                        </div>
                    ) : (
                        <table className='polling' style={{ borderCollapse: 'collapse', width: '100%', margin: 'auto' }}>
                            <tbody>
                                <tr>
                                    <td style={pollingColStyleTitle}>Server IPアドレス</td>
                                    <td style={pollingColStyle}>{data4GLteSetting4?.serverIpAddr}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>Server ポート</td>
                                    <td style={pollingColStyle}>{data4GLteSetting4?.serverPort}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>Modem IPアドレス</td>
                                    <td style={pollingColStyle}>{data4GLteSetting4?.modemIpAddr}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>Modem ポート</td>
                                    <td style={pollingColStyle}>{data4GLteSetting4?.modemPort}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>死活監視間隔</td>
                                    <td style={pollingColStyle}>{data4GLteSetting4?.serverTime}{showUnit(data4GLteSetting4?.serverTime, "時間")}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>再送回数</td>
                                    <td style={pollingColStyle}>{data4GLteSetting4?.ackTime}{showUnit(data4GLteSetting4?.ackTime, "回")}</td>
                                </tr>
                            </tbody>
                        </table>
                    )}
                    <Typography display='flex' justifyContent='flex-end' padding='4px 4px 0 0'>最終取得日時：{data4GLteSetting4?.lastGetDatetime ?? '-'}</Typography>
                </CardContent>
            </Card >
            {
                openSelectDialog ? (
                    <Select4GLteSettingDialog
                        isOpen={true}
                        onOK={(data) => handleUpdateOk(data)}
                        onCancel={handleUpdateCancel}
                        data={editData}
                        dialogTitle={updateDialogTitle}
                    />
                ) : (
                    <div />
                )
            }
            <FetchHelper fetchId={fetchId + deviceNos[0]} onComplete={(success, data, error) => success ? handleRefreshSuccess(data, deviceNos[0]) : handleError(success, data, error, deviceNos[0])} />
            <FetchHelper fetchId={fetchId + deviceNos[1]} onComplete={(success, data, error) => success ? handleRefreshSuccess(data, deviceNos[1]) : handleError(success, data, error, deviceNos[1])} />
            <FetchHelper fetchId={fetchId + deviceNos[2]} onComplete={(success, data, error) => success ? handleRefreshSuccess(data, deviceNos[2]) : handleError(success, data, error, deviceNos[2])} />
            <FetchHelper fetchId={fetchId + deviceNos[3]} onComplete={(success, data, error) => success ? handleRefreshSuccess(data, deviceNos[3]) : handleError(success, data, error, deviceNos[3])} />
            <FetchHelper fetchId={fetchId + deviceNos[4]} onComplete={(success, data, error) => success ? handleRefreshSuccess(data, deviceNos[4]) : handleError(success, data, error, deviceNos[4])} />
            <FetchHelper fetchId="UPDATE_DATA_4G_LTE_SETTING" method="POST" onComplete={(success, data, error) => success ? handleUpdateSuccess(success, data, error) : handleUpdateError(success, data, error)} />
        </>
    );
};
const mapStateToProps = (state: ApplicationState) => ({
    fetchState: selectors.getFetchState(
        state,
        fetchId
    ) as FetchState,
});
const mapDispatchToProps = {
    onUpdate: (code: string, mainid: string, data: any) => actionCreators.fetch("UPDATE_DATA_4G_LTE_SETTING", `/polling/set?code=${code}`, 'POST', data, false, true),
    onRefresh: (params: any, fetchId: string) => actionCreators.fetch(fetchId, `/polling/get`, "GET", params),
    onError: (success: boolean, data: any, error: any, deviceName: string) =>
        actionCreators.showMessage({
            type: "error",
            title: `4G LTE設定/${deviceName}取得`,
            body: "4G LTE設定取得できませんでした。",
        }),
    onUpdateSuccess: (deviceName: string) =>
        actionCreators.showMessage({
            type: "info",
            title: `4G LTE設定/${deviceName}変更`,
            body: "4G LTE設定を変更しました。",
        }),
    onUpdateError: (success: boolean, data: any, error: any, deviceName: string) =>
        actionCreators.showMessage({
            type: "error",
            title: `4G LTE設定/${deviceName}変更`,
            body: "4G LTE設定を変更できませんでした。",
        }),
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Cpn4GLteSetting);
